<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">Building <span class="gold">{{ mapName }}</span></h2>
  </div>

  <div class="wz-choice">
    @if (selectedMode === AiGenerationMode.Guided) {
      <div class="wz-choice-chips">
        <span class="wz-chip">1 credit</span>
        <span class="wz-chip is-plain">12 steps</span>
      </div>
      <h3 class="wz-choice-name">Guided</h3>
      <p class="wz-choice-tag">"You give the details, AI adds depth"</p>
      <p class="wz-lead">
        WorldTumbler reads the geography and politics in your map, you add your ideas, and AI writes connected lore for
        cultures, religions, states and provinces. Everything it writes stays fully editable as your story grows.
      </p>
    } @else {
      <div class="wz-choice-chips">
        <span class="wz-chip">1 credit</span>
        <span class="wz-chip is-plain">7 steps</span>
      </div>
      <h3 class="wz-choice-name">AI Assist</h3>
      <p class="wz-choice-tag">"Fast. Cohesive. Fully realised."</p>
      <p class="wz-lead">
        You set the themes, tone and key ideas; AI turns them into lore. The wizard walks you through cultures, religions,
        states and provinces while AI fills in the details: a deep world without starting from scratch.
      </p>
    }
  </div>

  <div class="wz-stats">
    <div class="wz-stat">
      <span>Credits needed</span>
      <strong>{{ creditsRequired }}</strong>
    </div>
    <div class="wz-stat" [class.is-short]="!isLoading && creditsBalance < creditsRequired"
      [class.is-ok]="!isLoading && creditsBalance >= creditsRequired">
      <span>Your balance</span>
      @if (isLoading) {
        <i class="wz-spinner" aria-label="Loading"></i>
      } @else {
        <strong>{{ creditsBalance }}</strong>
      }
    </div>
  </div>

  @if (!isLoading && creditsBalance < creditsRequired) {
    <div class="wz-note" role="status">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
      <p>You need a World Initialization Credit to continue. Buy one below; your balance updates as soon as you come back to this tab.</p>
    </div>
  }

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    @if (isLoading || creditsBalance < creditsRequired) {
      <button type="button" class="btn btn-dark" (click)="buyProduct()" [disabled]="isLoading || !purchasePack">
        Buy a credit · ${{ purchasePack?.price || '30' }}
      </button>
    }
    <button type="button" class="btn btn-theme" (click)="onProceed()" [disabled]="creditsBalance < creditsRequired || isLoading">
      Continue
    </button>
  </div>
</div>
